import React from 'react';

const AdminContent = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Content Management</h1>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <p className="text-gray-600">Admin content moderation page.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminContent;
